"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*

    Login
    
    All translations related to login data
    
    Verified by: Cédric Bloem
    Date: 12/12/2019
    identityBuilding bvba
    https://identitybuilding.be

*/
var Login = {
  login: {
    nl: 'Meld je aan',
    fr: 'Connecter',
    en: 'Log in'
  },
  logout: {
    nl: 'Meld je af',
    fr: 'Deconnecter',
    en: 'Log out'
  },
  instructions: {
    nl: 'Stuur mij instructies',
    fr: 'Envoie moi des instructions',
    en: 'Send me instructions'
  },
  username: {
    nl: 'Gebruikersnaam',
    fr: "Nom d'utilisateur",
    en: 'Username'
  },
  password: {
    nl: 'Wachtwoord',
    fr: 'Mot de passe',
    en: 'Password'
  },
  password_repeat: {
    nl: 'Wachtwoord herhalen',
    fr: 'Répéter mot de passe',
    en: 'Repeat password'
  },
  password_forgot: {
    nl: 'Wachtwoord vergeten?',
    fr: 'Oublié mot de passe',
    en: 'Forgot password?'
  },
  password_remember: {
    nl: 'Ik weet mijn wachtwoord weer!',
    fr: 'Je me suis rappelé mon mot de passe!',
    en: "Wait! I remember my password!"
  },
  message_forgot: {
    nl: "Geen zorgen, gebeurt iedereen wel eens ;)",
    fr: "Ne vous inqui\xE9tez pas, cela arrive aux meilleurs d'entre nous;)",
    en: "Don't worry, it happens to the best of us ;)"
  },
  feedback_mail_empty: {
    nl: 'Gelieve een e-mail adres in te vullen',
    fr: "Rempli votre adresse e-mail s'il vous plaît",
    en: 'Please fill in your email address'
  },
  feedback_mail_incorrect: {
    nl: 'We vinden geen gegevens met dit e-mail adres; typfoutje gemaakt?',
    fr: "Nous ne pouvons trouver aucune donnée avec cette adresse e-mail; faute de frappe?",
    en: "We can't find any data with this e-mail address; made a typo?"
  },
  feedback_mail_wrong: {
    nl: 'Dit e-mail adres bestaat niet',
    fr: "Cette adresse e-mail n'existe pas",
    en: "This email address does'nt exist"
  },
  feedback_pw_empty: {
    nl: 'Wees niet bang om je wachtwoord in te vullen',
    fr: "N'ayez pas peur de saisir votre mot de passe",
    en: "Don't be afraid to fill in your password"
  },
  feedback_pw_incorrect: {
    nl: 'Oeps! Dit is niet het juiste wachtwoord. Probeer nog eens als je wilt?',
    fr: "Oups! Ce n'est pas le bon mot de passe. Essaie encore si tu veux?",
    en: 'Oops! This is not the correct password. Try again if you want?'
  },
  feedback_unkown: {
    nl: 'Er is een onbekend probleem; we kijken dit na.',
    fr: 'Il y a un problème inconnu. nous vérifions cela.',
    en: "There is an unknown problem; we'll check this."
  },
  mail_sent: {
    nl: 'E-mail is verzonden!',
    fr: 'Le courrier a été envoyé!',
    en: 'Mail has been sent!'
  },
  mail_sent_error: {
    nl: 'Kan geen mail verzenden',
    fr: 'Impossible d\'envoyer du courrier',
    en: 'Can\'t send mail'
  }
};
var _default = Login;
exports["default"] = _default;